import { useNavigate } from 'react-router-dom';
import { XSGlobalHeaderActions } from '@xinosolutions/xs-shell';
import { useAccountMenuUser, useAuthActions } from '@xinosolutions/xs-auth-react';
import { useLogout } from '../../Hooks/useLogout';
import { useLearnixProduct } from '../../contexts/LearnixProductContext';
import { useContentSetting } from '../../Hooks/ContentSetting';
import { xsAccountUrl } from '../../config/xsAuth';

export default function ShellAccountActions({
  manageAccountUrl = xsAccountUrl,
  manageAccountLabel = 'Manage your XS Account',
  clearLocalSession,
}) {
  const navigate = useNavigate();
  const menuUser = useAccountMenuUser();
  const { switchAccount, addAccount, pending } = useAuthActions({ notifyError: true });
  const { signOut, pending: signOutPending } = useLogout({ clearLocalSession });
  const { refreshLearnixSession } = useLearnixProduct();
  const { STOP_SOCKET_FORCEFULLY } = useContentSetting();

  const handleSwitchAccount = async () => {
    try {
      await STOP_SOCKET_FORCEFULLY();
      await switchAccount();
      // ProductSession can keep a stale member_init payload after XS Auth account
      // switch; refresh so dashboard re-applies teacher/associate sidebar.
      await refreshLearnixSession();
      navigate('/dashboard', { replace: true });
    } catch {
      /* notifyError on useAuthActions; popup closed is ignored upstream.
         Re-hydrate so we restore socket/sidebar if switch was cancelled. */
      try {
        await refreshLearnixSession();
      } catch {
        /* ignore */
      }
    }
  };

  return (
    <XSGlobalHeaderActions
      user={menuUser}
      manageAccountUrl={manageAccountUrl}
      manageAccountLabel={manageAccountLabel}
      onSwitchAccount={() => {
        handleSwitchAccount().catch(() => {});
      }}
      onAddAccount={() => {
        addAccount().catch(() => {});
      }}
      onSignOut={() => {
        signOut().catch(() => {});
      }}
      switchPending={pending}
      signOutPending={signOutPending}
    />
  );
}
